import VerticalTabs from "../../components/VerticalTabs"

import CoronationSquareGallery from "./CoronationSquareGallery"
// import AmenitiesGallery from "./AmenitiesGallery"
import ResidencesGallery from "./ResidencesGallery"
import LifestyleGallery from "./LifestyleGallery"

const tabs = [
  {
    name: "CORONATION SQUARE",
    component: CoronationSquareGallery
  },
  {
    name: "RESIDENCES",
    component: ResidencesGallery
  },
  // {
  //   name: "AMENITIES",
  //   component: AmenitiesGallery
  // },
  {
    name: "LIFESTYLE",
    component: LifestyleGallery
  }
]

const Gallery = ({ match: { url } }) => <VerticalTabs path={url} tabs={tabs} />

export default Gallery
